import axios from "axios";
import { ResponseType } from "src/types";

export const Post = (url: string, params: any) =>
    axios.post(url, params) as unknown as Promise < ResponseType<any>>

export const Get = (url: string) =>
    axios.get(url) as unknown as Promise <ResponseType<any>>

export const Delete = (url: string) =>
    axios.delete(url) as unknown as Promise <ResponseType<any>>
